module.exports = __webpack_public_path__ + "static/media/Logo_PolAir_Blanc.0fac0bf4.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/Logo_PolAir_Blanc.svg
// module id = 743
// module chunks = 0